var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('p',[_vm._v(" This inspection detects when one or more instances of an application are not available or have been restarted. ")]),_c('v-card',[_c('v-img',{attrs:{"eager":"","src":"/static/img/docs/coroot-ce/inspections/instances.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }